import React, { useState } from 'react';
import DashboardWidgetNew from './DashboardWidgetNew';

const Categories = () => {
  const [filters, setFilters] = useState({});

  const getChartTitle = filters => {
    if (filters.operation === 'investment') {
      return 'Category Based Investment Trend ($)';
    }
    if (filters.operation === 'git_effort') {
      return 'Category Based Effort Trend';
    }
    return 'Category Based Commit Trend';
  };

  const dashboardFilters = filter => {
    setFilters(filter);
  };

  return (
    <DashboardWidgetNew
      category="categories"
      dashboardFilters={dashboardFilters}
      serviceURL="/dashboard/get-table-data-categories"
      title={{
        chartTitle: getChartTitle(filters),
        pieTitle: 'Categories - Pie',
        tableColumnName: 'Categories'
      }}
      isHidden={['categories', 'viewType']}
      forceClearMultiFilters={['categories']}
    />
  );
};

export default Categories;
